export const environment = {
  production: false,
  //apiAuthUrl: 'https://localhost:44315/api/oAuth/',
  //apiSignupUrl: 'https://localhost:44315/api/services/signup/',
  //apiFALServices: 'https://localhost:44315/api/services/',
  //apiValidateUrl: 'https://localhost:44354/api/authorization/auth/',
  //apiNettTracker: 'https://localhost:44354/api/nettTracker/',
  //apiFAR: 'https://localhost:44354/api/services/fixedAssetRegister/',
  //apiLogging: 'https://localhost:44354/api/netttracker/loggingproxy',
  //apiHelp: 'https://localhost:44315/api/services/helpCentre',
  loginUrl: '/login',
  companyListUrl: '/company',
  orgListUrl: '/account/organisations',
  createCompanyUrl: '/create-company',
  homeUrl: '/home',
  companyHomeUrl: '/dashboard',
  reconnectCompleteUrl: '/company/details',
  unauthorisedUrl: '/unauthorised',
  reconnectUrl: '/company/reconnect',
  createAccountUrl: '/account/create',
  signupUrl: '/signup',
  learnMore: '/learnmore',
  verifyUrl: '/account/verify-email',
  disableAuth: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
